package org.mkui.font

enum class Posture {
    REGULAR, ITALIC
}